var map = {
	"./Relu-Activation-Function.gif": 117,
	"./acti.gif": 118,
	"./activation-functions.gif": 119,
	"./adrashya-sms.png": 120,
	"./blackstone.png": 121,
	"./brandspring.png": 122,
	"./butterfly.png": 123,
	"./learngita.png": 124,
	"./neural.gif": 125,
	"./news.gif": 126,
	"./project-01.png": 127,
	"./project-02.png": 128,
	"./project-03.png": 129,
	"./project-04.png": 130,
	"./project-05.png": 131,
	"./project-06.png": 132,
	"./project-07.png": 133,
	"./voice.gif": 134,
	"./whsuites.png": 135,
	"./whsuites2.png": 136,
	"./wrirk-crm.png": 137,
	"./wrirk.png": 138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;